/* 03 · THE THEATER (test). One film after another on the screen: title card → the last few seconds of the spoon
   clip (the spoon coming up loaded) → projector flash → next. Plays only while on screen. The hooded head is in
   the seats during every third film. Reduced motion: no autoplay — the first film's title card, name and button. */
(function () {
  var root = document.querySelector('[data-nhp-thr]');
  if (!root) return;
  var list = root.querySelector('[data-nhp-thr-list]');
  var items = Array.prototype.slice.call(list.querySelectorAll(list.hasAttribute('data-only-new') ? 'li[data-new]' : 'li')).map(function (li) { return li.dataset; });
  if (!items.length) return;
  var q = function (s) { return root.querySelector(s); };
  var video = q('[data-nhp-thr-video]'), screen = q('[data-nhp-thr-screen]'), flash = q('[data-nhp-thr-flash]');
  var titleImg = q('[data-nhp-thr-title]'), titleText = q('[data-nhp-thr-titletext]');
  var film = q('[data-nhp-thr-film]'), flavor = q('[data-nhp-thr-flavor]'), buy = q('[data-nhp-thr-buy]'), pause = q('[data-nhp-thr-pause]');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TAIL = 4.2;                 // seconds of each clip shown: the spoon coming up
  var i = -1, wanted = true, onScreen = false, timer = null, started = false;

  function label(it) {
    film.textContent = it.film; film.href = it.url; screen.href = it.url;
    screen.setAttribute('aria-label', it.film + ': ' + it.flavor);
    flavor.textContent = it.flavor;
    buy.setAttribute('data-nhp-add', it.variant);
    if (it.title) { titleImg.src = it.title; } else { titleImg.removeAttribute('src'); }
    titleText.textContent = it.film;
  }

  function cutFlash() {
    if (reduce) return;
    flash.classList.remove('is-go'); void flash.offsetWidth; flash.classList.add('is-go');
  }

  function next() {
    clearTimeout(timer);
    i = (i + 1) % items.length;
    var it = items[i];
    label(it);
    root.classList.add('is-card');
    root.style.setProperty('--thr-glow', it.glow || '#E63329');
    // he is not there… then he is in the back row… then the row in front of you… then gone
    var beat = items.length > 2 ? i % Math.max(4, items.length) : -1;
    root.classList.toggle('has-watcher', beat === 1);
    root.classList.toggle('has-watcher-near', beat === 2);
    cutFlash();
    video.pause();
    video.src = it.clip;
    video.load();
    var shown = Date.now();
    video.addEventListener('loadedmetadata', function onMeta() {
      video.removeEventListener('loadedmetadata', onMeta);
      video.currentTime = Math.max(0, (video.duration || TAIL) - TAIL);
      // the title card holds at least 1.2s, then the film starts
      timer = setTimeout(function () {
        if (!(wanted && onScreen)) return;
        cutFlash();
        root.classList.remove('is-card');
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      }, Math.max(0, 1200 - (Date.now() - shown)));
    });
  }
  video.addEventListener('ended', function () { if (wanted && onScreen) next(); });

  function apply() {
    pause.setAttribute('aria-pressed', wanted ? 'false' : 'true');
    pause.querySelector('.nhp-sr').textContent = wanted ? 'Pause the film' : 'Play the film';
    if (wanted && onScreen) {
      if (!started) { started = true; next(); }
      else if (root.classList.contains('is-card')) next_resume();
      else { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    } else { video.pause(); clearTimeout(timer); }
  }
  function next_resume() { i = (i - 1 + items.length) % items.length; next(); }

  // one tile of snow for the storm
  (function () {
    var c = document.createElement('canvas'); c.width = 120; c.height = 90;
    var x = c.getContext('2d'), d = x.createImageData(120, 90);
    for (var k = 0; k < d.data.length; k += 4) { var v = Math.random() * 255 | 0; d.data[k] = d.data[k + 1] = d.data[k + 2] = v; d.data[k + 3] = 255; }
    x.putImageData(d, 0, 0);
    root.style.setProperty('--thr-snow', 'url(' + c.toDataURL() + ')');
  })();

  label(items[0]);
  root.classList.add('is-card');
  if (reduce || !('IntersectionObserver' in window)) { pause.hidden = true; return; }
  pause.addEventListener('click', function () { wanted = !wanted; apply(); });
  new IntersectionObserver(function (entries) { onScreen = entries[0].isIntersecting; apply(); }, { threshold: 0.35 }).observe(root.querySelector('.nhp-thr__room'));
  document.addEventListener('visibilitychange', function () { if (document.hidden) { video.pause(); clearTimeout(timer); } else apply(); });
})();
